import { getAffinities } from './dy-affinity-sort';
import { TAO_KOE } from '../libs';

const injectSearchTermBrands = async( searchTermsContainerEl ) => {
	const searchTermsEls = searchTermsContainerEl.querySelectorAll( '.mdl_search__initial .mdl_search__suggestions-searchterm' );
	let searchTermsElsArray = Array.from( searchTermsEls );
	const insertSpots = [ 2, 4, 6 ];
	const maxInjectedBrandsCount = 3;
	const maxTotalSearchTermsCount = 9;

	const affinities = await getAffinities();

	//Sort brands by score
	const favoriteBrandsByAffinity = Object.entries( affinities.brand ?? [] ).sort( ( [ , a ], [ , b ] ) => b - a ).map( ( item ) => item[ 0 ] ).slice( 0, maxInjectedBrandsCount );

	if ( Object.keys( favoriteBrandsByAffinity ).length !== 0 ) {
		//Remove elements which are already in search terms
		searchTermsElsArray = searchTermsElsArray.filter( ( searchTerm ) => ! favoriteBrandsByAffinity.map( ( brand ) => brand.toLowerCase() ).includes( searchTerm.innerText.toLowerCase() ) );

		//Add new search terms because of brand affinity
		favoriteBrandsByAffinity.forEach( ( brand, index ) => {
			const newElem = document.createElement( 'a' );
			newElem.setAttribute( 'href', '/shop-suche/?query=' + encodeURIComponent( brand ) );
			newElem.classList.add( 'mdl_search__suggestions-searchterm' );
			newElem.setAttribute( 'rel', 'nofollow' );
			newElem.dataset.injected = true;
			newElem.innerText = brand.toLowerCase();
			searchTermsElsArray.splice( insertSpots[ index ] === 0 ? 0 : insertSpots[ index ] - 1, 0, newElem );
		} );

		//Reduce search tearms to max 9 entries
		searchTermsElsArray = searchTermsElsArray.slice( 0, maxTotalSearchTermsCount );

		//Append the new search term entries
		searchTermsContainerEl.innerHTML = '';
		searchTermsElsArray.forEach( ( searchTermEl ) => {
			searchTermsContainerEl.appendChild( searchTermEl );
		} );
	}
};

const initAffinitySearchTerms = ( scopeEl = document ) => {
	const searchTermsContainerEls = scopeEl.querySelectorAll( '.mdl_search__initial .mdl_search__suggestions-searchterms' );
	searchTermsContainerEls.forEach( ( searchTermsContainerEl ) => {
		injectSearchTermBrands( searchTermsContainerEl );
	} );
};

// Init.
TAO_KOE.ready( 'dy-affinity-search.js', () => initAffinitySearchTerms() );

// Export.
export {
	getAffinities,
	initAffinitySearchTerms,
};
